<template>
  <div :class="$style.wrap">
    <!-- 申请条件 -->
    <template v-if="active == 0">
      <template v-if="clearLockText.length > 0">
        <div :class="['tip_wrap', $style.text_wrap]">
          <tip-icon iconName="key" />
          <div :class="$style.rightContent" v-html="clearLockText"></div>
        </div>
        <van-button
          round
          type="primary"
          size="large"
          tag="input"
          :value="buttonName"
          native-type="submit"
          @click.stop.prevent="onSubmit"
        />
      </template>
    </template>
    <!-- 选择服务器 -->
    <template v-else>
      <h3 :class="['title_wrap', $style.server]" v-if="active == 1">
        请选择您需要清除密码锁的区服
      </h3>
      <phone-verification :phone="phone" v-else />
      <base-form
        ref="form"
        :currentIndex="active"
        :key="active"
        :actions="actions"
        :items="data"
        :submit-text="buttonName"
        label-width="4em"
        @giveData="giveData"
        @actionShow="handlerAction"
        @setActionValue="setActionValue"
        @submit="onSubmit"
      />
    </template>
  </div>
</template>
<script>
import { minxinActive } from "@/mixins/minxinActive";
import { clearLock, contentInit } from "@/http/serve";
import { mapGetters, mapActions } from "vuex";
import tipIcon from "../components/TipIcon";
import phoneVerification from "../components/PhoneVerification";
import BaseForm from "@/components/BaseForm";

export default {
  name: "clearLock",
  components: {
    tipIcon,
    phoneVerification,
    BaseForm
  },
  mixins: [minxinActive],
  data() {
    return {
      phone: this.$ls.get("phone", ""), //绑定的手机号
      clearLockText: "", //清除的提示内容
      actions: [], //picker选项
      dataList: this.$ls.get("dataList") || [
        { title: "第一步", filed: [] },
        {
          title: "第二步",
          filed: [{ name: "server", readonly: true, iconType: 1, actions: [] }]
        },
        {
          title: "第三步",
          filed: [{ name: "telCode", moduleType: true, type: 6 }]
        }
      ]
    };
  },
  mounted() {
    this.SetLeave(false);
    this.getWebContent();
  },
  computed: {
    ...mapGetters(["gameId"]),
    buttonName() {
      let nameList = {
        "0": "清除密码锁",
        "1": "下一步",
        "2": "验证"
      };
      return nameList[this.active];
    },
    data() {
      return this.dataList[this.active].filed;
    }
  },
  methods: {
    ...mapActions(["SetLeave"]),
    /**
     * @description 清除密码锁
     * @param {number} type  - 验证类型
     * @param {object} formdata  - 表单对象值
     */
    async clearLock(type, formdata) {
      let params = {
        type: type,
        game_id: this.gameId
      };
      if (type != 1) {
        params.server_id = this.getFieldValue(1, "server", "id");
      }
      if (type == 3) {
        let { telCode } = formdata;
        params.code = telCode;
      }
      if (type == 2 && params.server_id == "") {
        this.$toast("请选择游戏服务器");
        this.handlerForm();
        return false;
      }
      let res = await clearLock(params);
      let { rcode, data, redsc } = res;
      if (rcode != 0) {
        this.handlerForm();
        return false;
      }
      this.clearEvent(type, data, redsc);
    },
    /**
     * @description 获取网页协议内容
     */
    async getWebContent() {
      let parmas = {
        game_id: this.gameId,
        content_type: "clearLock"
      };
      let res = await contentInit(parmas);
      let { rcode, data } = res;
      if (rcode != 0) return;
      let { clearLock } = data;
      this.clearLockText = clearLock;
    },
    /**
     * @description 清除事件步骤
     * @param {number} type  - 验证类型
     * @param {object} formdata  - 表单对象值
     */
    clearEvent(type, data) {
      let eventList = {
        "1": () => {
          this.setFieldValue(1, "server", data, "actions");
          this.setActive();
        },
        "2": () => {
          let { s_phone } = data;
          this.phone = s_phone;
          this.$ls.set("phone", this.phone);
          this.setActive();
        },
        "3": () => {
          if (this.gameId == 5) {
            this.$Dialog
              .alert({
                title: "操作成功",
                message: "密码锁将在24小时之后解除"
              })
              .then(() => {
                this.resetData();
              });
          } else {
            this.$Dialog
              .alert({
                title: "密码锁清除成功"
              })
              .then(() => {
                this.resetData();
              });
          }
        }
      };
      this.handlerForm();
      eventList[type]();
    },

    /**
     * @description 设置picker选中值
     */
    setActionValue(index, item) {
      let { text, id } = item;
      this.setFieldValue(1, "server", id, "id");
      this.setFieldValue(1, "server", text);
    },
    /**
     * @description 重置页面数据变为初始值
     */
    resetData() {
      //重置
      this.dataList = [
        { title: "第一步", filed: [] },
        {
          title: "第二步",
          filed: [{ name: "server", readonly: true, iconType: 1, actions: [] }]
        },
        {
          title: "第三步",
          filed: [{ name: "telCode", moduleType: true, type: 6 }]
        }
      ];
      this.active = 0;
      this.$ls.set("active", this.active);
      this.$ls.remove("phone");
      this.$ls.set("dataList", this.dataList);
    },
    /**
     * @description 提交问题
     * @param {object} formdata  - 表单对象值
     */
    onSubmit(formdata) {
      let listEvent = {
        "0": () => {
          this.clearLock(1);
        },
        "1": () => {
          this.clearLock(2);
        },
        "2": () => {
          this.clearLock(3, formdata);
        }
      };

      listEvent[this.active]();
    },
    /**
     * @description 页面步骤回退
     */
    goBack() {
      if (this.active === 2) {
        //清空第三步填的验证码
        this.resetFieldValue(2, "telCode");
        this.backActive();
        this.getWebContent();
        return false;
      } else if (this.active === 1) {
        //清空第二步填的服务器
        this.setFieldValue(1, "server", "", "id");
        this.setFieldValue(1, "server");
        this.backActive();
        this.getWebContent();
        return false;
      }
      return true;
    },
    /**
     * @description 移除存储数据
     */
    removeAll() {
      let lsList = ["phone", "dataList", "active"];

      this.lsRemove(lsList);
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  .size(100%, auto);
  .flex-center;
  .flex-col;
  padding-top: 2rem;
  form {
    .size(100%, auto);
  }
  .server {
    padding-left: 1rem;
  }
  .text_wrap {
    margin-bottom: 0.77rem;
    .flex-justify-center;
    .rightContent {
      width: 65%;
    }
  }
}
</style>
